import { useState, useEffect, useContext } from "react";

import UsuarioContext from "../../../../../../../context/userContext/context";
import { NEW_WITHDRAWAL_STEPS } from "../../../../../../@enums";
import { profileDetails } from "../../../../../../services/profile.service";
import { ConfirmWithdrawal } from "./steps/ConfirmWithdrawal";
import { RequestWithdrawal } from "./steps/RequestWithdrawal";

export const NewWithdrawal = (): JSX.Element => {
    const { user } = useContext(UsuarioContext)

    const [indexStep, setIndexStep] = useState<number>(NEW_WITHDRAWAL_STEPS.requestWithdrawal);
    const [balance, setBalance] = useState<number>(0);
    const [balanceAfterWithdrawal, setBalanceAfterWithdrawal] = useState<number>(0);
    const [withdrawalValue, setWithdrawalValue] = useState<number>(0);
    const [accountSelected, setAccountSelected] = useState();

    const steps = [
        <RequestWithdrawal 
            balance={balance}
            withdrawalValue={withdrawalValue}
            setWithdrawalValue={setWithdrawalValue}
            addAccountSelected={setAccountSelected}
            setIndexStep={setIndexStep}
        />,
        <ConfirmWithdrawal
            balance={balanceAfterWithdrawal}
            withdrawalValue={withdrawalValue}
            account={accountSelected}
            setIndexStep={setIndexStep}
        />
    ]

    const handleAdjustBalanace = () => {
        let newBalance = Math.round(balance * 100) / 100 - Math.round(withdrawalValue * 100) / 100;
        setBalanceAfterWithdrawal(newBalance)
    }

    useEffect(() => {
        profileDetails(user.id).then(data => {
            setBalance(data.total_money)
        });
    }, [])

    useEffect(() => {
        handleAdjustBalanace();
    }, [withdrawalValue])

    return (
        <>
            {steps[indexStep]}
        </>
    )
}